import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, Alert } from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { useAuth } from "./AuthContext";

const { Title, Text } = Typography;

const Login = () => {
    const { login } = useAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const onFinish = async ({ email, password }) => {
        setError(null);
        setLoading(true);
        try {
            await login(email, password);
        } catch (err) {
            if (err.status === 429) {
                setError(
                    "Too many failed attempts. Please try again in 15 minutes."
                );
            } else {
                setError(err.message || "Login failed");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login">
            <Card className="admin-login__card" variant="borderless">
                <div className="admin-login__head">
                    <Title level={3} style={{ margin: 0 }}>
                        Ctrl Events
                    </Title>
                    <Text type="secondary">Admin Panel</Text>
                </div>

                {error && (
                    <Alert
                        type="error"
                        showIcon
                        message={error}
                        style={{ marginBottom: 16 }}
                    />
                )}

                <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[{ required: true, message: "Enter your email" }]}
                    >
                        <Input
                            size="large"
                            prefix={<MailOutlined />}
                            placeholder="admin@example.com"
                            autoComplete="username"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                            { required: true, message: "Enter your password" },
                        ]}
                    >
                        <Input.Password
                            size="large"
                            prefix={<LockOutlined />}
                            placeholder="••••••••"
                            autoComplete="current-password"
                        />
                    </Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        block
                        loading={loading}
                    >
                        Sign in
                    </Button>
                </Form>
            </Card>
        </div>
    );
};

export default Login;
